import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'markdown'
})
export class MarkdownPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return '';

    let html = value;

    // Convert bold **text** or __text__
    html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/__(.+?)__/g, '<strong>$1</strong>');

    // Convert italic *text* or _text_
    html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');
    html = html.replace(/_(.+?)_/g, '<em>$1</em>');

    // Convert inline code `code`
    html = html.replace(/`(.+?)`/g, '<code>$1</code>');

    // Convert line breaks
    html = html.replace(/\n/g, '<br>');

    // Convert unordered lists (lines starting with - or *)
    html = html.replace(/^[\-\*] (.+)$/gm, '<li>$1</li>');
    html = html.replace(/(<li>.*<\/li>)/s, '<ul>$1</ul>');

    // Convert numbered lists
    html = html.replace(/^\d+\. (.+)$/gm, '<li>$1</li>');

    // Wrap paragraphs (simple approach - split by double line breaks)
    const paragraphs = html.split(/<br><br>/g);
    if (paragraphs.length > 1) {
      html = paragraphs
        .filter(p => p.trim())
        .map(p => {
          // Don't wrap if already in a list or other block element
          if (p.startsWith('<ul>') || p.startsWith('<ol>') || p.startsWith('<li>')) {
            return p;
          }
          return `<p>${p}</p>`;
        })
        .join('');
    }

    return this.sanitizer.sanitize(1, html) || '';
  }
}
